import React, { WheelEvent, InputHTMLAttributes } from 'react';
import { InputContainer, StyledInput } from './styled';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  isError?: boolean;
};

const Input = ({ isError, ...inputProps }: Props): JSX.Element => {
  const numberInputOnWheelPreventChange = (e: WheelEvent) => {
    const target = e.target as HTMLInputElement;

    target?.blur();

    e.stopPropagation();
  };

  return (
    <InputContainer>
      <StyledInput
        isError={isError}
        onWheel={numberInputOnWheelPreventChange}
        {...inputProps}
      />
    </InputContainer>
  );
};

export default Input;
